
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Home,
  ShoppingBag,
  Calendar,
  CreditCard,
  Gift,
  MessageCircle,
  User
} from 'lucide-react';

const AppMobileNav = () => {
  const location = useLocation();

  const navItems = [
    {
      name: 'Home',
      href: '/app/patient/dashboard',
      icon: Home,
      active: location.pathname === '/app/patient/dashboard'
    },
    {
      name: 'Shop',
      href: '/app/patient/shop',
      icon: ShoppingBag,
      active: location.pathname.startsWith('/app/patient/shop')
    },
    {
      name: 'Book',
      href: '/app/patient/book',
      icon: Calendar,
      active: location.pathname === '/app/patient/book'
    },
    {
      name: 'Credits',
      href: '/app/patient/credits',
      icon: CreditCard,
      active: location.pathname === '/app/patient/credits'
    },
    {
      name: 'Rewards',
      href: '/app/patient/rewards',
      icon: Gift,
      active: location.pathname === '/app/patient/rewards'
    }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-2 safe-area-bottom z-50">
      <nav className="flex justify-around">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.name}
              to={item.href}
              className={`flex flex-col items-center py-2 px-1 min-w-0 ${
                item.active
                  ? 'text-juv-terracotta'
                  : 'text-gray-600 hover:text-juv-terracotta'
              }`}
            >
              <Icon className="w-6 h-6 mb-1" />
              <span className="text-xs font-medium truncate">{item.name}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default AppMobileNav;
